import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import StatusIndicator, {
  type StatusIndicatorProps,
} from '@cloudscape-design/components/status-indicator';
import type { TenantStatus } from '@etiquetachef/types';

// Sprint 39: migrado para o <StatusIndicator> do Cloudscape (cor + ícone
// semânticos), mantendo o texto traduzido de `tenants.status.*`.
const STATUS_TYPE: Record<TenantStatus, StatusIndicatorProps.Type> = {
  ACTIVE: 'success',
  SUSPENDED_BILLING: 'warning',
  SUSPENDED_ADMIN: 'error',
  DELETED: 'stopped',
};

/** `tenant.status` cru (estado operacional), traduzido, nas tabelas de empresas. */
export function StatusBadge({ status }: { status: TenantStatus }): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <StatusIndicator type={STATUS_TYPE[status]}>
      {t(`tenants.status.${status}`)}
    </StatusIndicator>
  );
}
